import React, { Component } from "react"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import TweenLite, { Power2 } from "gsap/umd/TweenMax"
import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"

import { selectEraContent } from "./../../selectors.js"
import { getEraIdFromYear } from "./../../helpers/helpers"

// Components
import "./style.css"
import HalfLeftChurchIcon from "./../../images/HalfLeftChurchIcon"
import HalfRightChurchIcon from "./../../images/HalfRightChurchIcon"

// Fokuset til slideren blir ikke satt riktig når navigert fra forsiden
// Ved navigering fra filteret, så fungerer det fint
// Så hva er forskjellen mellom de to? Der har du antagelig løsningen i hvertfall

class EraBox extends Component {
    constructor () {
        super()

        this.state = {
            activeEra: null,
            eraContentOpen: false,
            sliderLoaded: false,
            slideNumber: 0
        }

        this.setNewEra = this.setNewEra.bind(this)
        this.showMoreEraContent = this.showMoreEraContent.bind(this)
        this.setActiveEra = this.setActiveEra.bind(this)
    }

    componentDidUpdate (prevProps, prevState) {
        const thisActiveEra = this.props.activeEra
        const prevActiveEra = prevProps.activeEra

        const thisSlideNumber = this.state.slideNumber
        const prevSlideNumber = prevState.slideNumber

        if (thisActiveEra !== prevActiveEra && thisActiveEra) {
            this.setActiveEra(thisActiveEra)
        }

        // Sets the slider to the correct slide
        if (thisSlideNumber !== prevSlideNumber && thisSlideNumber) {
            this.slider.slickGoTo(thisSlideNumber)
        }
    }

    componentDidMount () {
        if (!this.props.activeEra) this.setState({ activeEra: this.props.era[0].fields.id})
        else this.setActiveEra(this.props.activeEra)
    }

    setActiveEra (activeEra) {
        const year = getEraIdFromYear(activeEra)

        const eraIndex = this.props.era.findIndex(item => item.fields.id === year)
        this.setState({ activeEra: year })

        if (eraIndex !== -1) {
            // Triggers componentDidUpdate and sets the slider to the correct slide
            this.setState({ slideNumber: eraIndex})
            this.setNewEra(eraIndex)
        }
    }

    setNewEra (slide) {
        const era = this.props.era[slide]
        this.setState({ activeEra: era.fields.id })
    }

    showMoreEraContent (keepOpen = false) {
        const { eraContentOpen } = this.state

        const eraContentHeightBefore = this.eraContent.clientHeight

        if (keepOpen || !eraContentOpen) {
            TweenLite.set(this.eraContent, {display: "block", height: "auto"})
            const eraContentHeight = this.eraContent.clientHeight

            TweenLite.fromTo(this.eraContent, 0.5, {height: `${eraContentHeightBefore}px`}, {height: `${eraContentHeight}px`, ease: Power2.linear})
        } else {
            TweenLite.fromTo(this.eraContent, 0.5, {height: `${eraContentHeightBefore}px`}, {height: "0px", ease: Power2.linear})
        }

        if (!keepOpen) this.setState({ eraContentOpen: !eraContentOpen })
    }

    render () {
        const { era } = this.props
        const { activeEra, eraContentOpen } = this.state

        // if (!era || !activeEra) return null
        const eraContent = era.find(item => item.fields.id === (activeEra ? activeEra : "1000"))

        const settings = {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            variableWidth: true,
            centerMode: true,
            focusOnSelect: true,
            centerPadding: 0,
            afterChange: (slide) => {
                // It sometimes initiates with negative numbers
                slide >= 0 && this.setNewEra(slide)
                slide >= 0 && this.props.onEraChange && this.props.onEraChange(era[slide])
                eraContentOpen && this.showMoreEraContent(true)
            }
        }

        const text = eraContent.fields.body
        const textSplit = text.split(".").slice(0, 2) // Henter et utdrag
        const textSplit2 = text.split(".").slice(2, -1) // Henter et utdrag
        const contentPreview = textSplit.join(". ")
        const restOfContent = textSplit2.join(". ")

        return (
            <div className="era-box church-theme-box church-theme-box--purple">
                <HalfLeftChurchIcon color="#7360EB" />
                <HalfRightChurchIcon color="#7360EB" />
                <div className="era-box-years">
                    <div className="era-box-years-inner">

                        <Slider {...settings} ref={comp => { this.slider = comp }}>
                            { era.map((data, index) =>
                                <li
                                    className={`era-box__year ${(data.fields.id === activeEra) ? "era-box__year--active" : ""}`}
                                    id={data.fields.id}
                                    key={index}>
                                    {data.fields.title}
                                </li>
                            )}
                        </Slider>

                    </div>
                </div>
                <div className="church-theme-box__inner">
                    <p>{ contentPreview }.</p>
                    <p id="yolo" ref={comp => { this.eraContent = comp }}>{ restOfContent }.</p>
                    <button className="church-theme-box__load-more-btn" onClick={() => this.showMoreEraContent(false)}>
                        {!eraContentOpen ? `+ Les mer om ${eraContent.fields.title}` : "- Minimer text"}
                    </button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = createStructuredSelector({
    era: selectEraContent()
})

export default connect(mapStateToProps)(EraBox)



// WEBPACK FOOTER //
// ./src/components/EraBox/index.js